import * as R from 'ramda'
import momentNs from 'moment'
const moment = momentNs

export function getMonthsFilter(): { name: string; id: number }[] {
  return <{ name: string; id: number }[]>R.addIndex(R.map)((month, i) => ({ name: month, id: i }))(moment.months())
}
